export default {
	'THEME': 'fwgch',
	"FEATURE_ADDITIONALPRODUCTS": false,
	"FEATURE_CHILDPRODUCTS": false,
	"FEATURE_LIMITEDSTOCK": false,
	"FEATURE_RESERVATION": false,
	"FEATURE_ORDERBOX_LOGIN": false,
	"FEATURE_ORDERBOX_DELIVERY": false,
	"FEATURE_ORDERBOX_TAKEAWAY": false,
	"FEATURE_ORDERBOX_REGIONS": false,
	"FEATURE_ORDERBOX_GEOLOCATION": false,
	"FEATURE_REFERRAL": false,
	"FEATURE_NEWSLETTER_REGISTRATION": false,
	"FEATURE_NEWSLETTER_CHECKOUT": false,
	"FEATURE_CO2_OPTOUT": false,
	"FEATURE_CO2_OPTOUT_PHASE2": false,
	"FEATURE_REUSABLE_DISHES": false,
	"FEATURE_NUTRITION_DETAILS": false,
	"FEATURE_NUTRITION_DETAILS_ALLERGENS": false,
	"FEATURE_NUTRITION_DETAILS_NUTRITION": false,
	"FEATURE_NUTRITION_DETAILS_CO2": false,
	"FEATURE_NUTRITION_DETAILS_TASTES": false,
	"FEATURE_NUTRITION_DETAILS_CART": false,
	"FEATURE_ALLERGEN_LIST": false,
	"FEATURE_MENU_SHOP": false,
	"FEATURE_CART_ITEM_NOTES": false,
	"FEATURE_GROUP_ORDERS": false,
	"FEATURE_ORDER_NPS": false,
	"FEATURE_TIP_VARIANTS": false,
	"FEATURE_PRODUCT_CO2_REMOVAL": false,
  "FEATURE_LIVE_ORDER_STATE": false,
  "FEATURE_POINZ": false,
  "FEATURE_POINZ_REGISTER": false,
  "FEATURE_ACCOUNT": false,
  "FEATURE_ACCOUNT_LOGGEDIN": true,
  "FEATURE_ACCOUNT_CREATE_CHECKOUT": false,
  "FEATURE_REWARDZ_TEASER_SUCCESS": false,
}
